const environment = process.env.VUE_APP_ENVIRONMENT
  ? process.env.VUE_APP_ENVIRONMENT
  : 'localhost';
var baseURL = process.env.VUE_APP_BASE_URL
  ? process.env.VUE_APP_BASE_URL
  : 'http://localhost:5001';
var TEDURL=process.env.VUE_APP_TED_URL?process.env.VUE_APP_TED_URL:'http://localhost'
var MOBEURL=process.env.VUE_APP_MOBE_URL?process.env.VUE_APP_MOBE_URL:'http://localhost'
var PACEURL=process.env.VUE_APP_PACE_URL?process.env.VUE_APP_PACE_URL:'http://localhost'
var BASEURLHOST = process.env.VUE_APP_BASEURLHOST
  ? process.env.VUE_APP_BASEURLHOST
  : 'http://localhost';
var PORT = 5001;
var PartnerSpId = process.env.VUE_APP_MYIDPARTNERSPID
  ? process.env.VUE_APP_MYIDPARTNERSPID
  : 5001;
var MYIDURL = process.env.VUE_APP_MYIDURL
  ? process.env.VUE_APP_MYIDURL
  : 'https://idp.myid.disney.com/idp/startSSO.ping?PartnerSpId';

var myIdConfigs = {
  url: MYIDURL + '=' + PartnerSpId,
  issuer: process.env.VUE_APP_MYIDISSUER
    ? process.env.VUE_APP_MYIDISSUER
    : 'https://idp.myid.disney.com/idp/SSO.saml2',
  cert: process.env.VUE_APP_MYIDCERT ? process.env.VUE_APP_MYIDCERT : '',
};

const testLogin = environment === 'dev' || environment === 'localhost';

module.exports = {
  TEDURL,
  MOBEURL,
  PACEURL,
  baseURL: baseURL,
  PORT: PORT,
  BASEURLHOST: BASEURLHOST,
  myIdConfigs: myIdConfigs,
  // baseURL:'http://ted.qentelli.io:5001',
  // baseURL: "http://3.135.130.147:5001",
  // baseURL:"http://localhost:5001",
  // baseURL:"http://192.168.1.2:5001",
  // baseURL:'http://ppbpe-lb-900452650.us-east-1.elb.amazonaws.com:5001',
  development: {
    config_id: 'development',
    app_name: 'TED',
    app_desc: 'TED V3.0',
    node_port: 5001,
    json_indentation: 4,
    database: 'ted',
  },
  testing: {
    config_id: 'testing',
    database: 'ted',
  },
  staging: {
    config_id: 'staging',
    node_port: 5001,
    database: 'ted',
  },
  production: {
    config_id: 'production',
    node_port: 5001,
    database: 'ted',
  },
  superadmin: 'TED Administrator',
  chartinterval: 1000 * 60 * 15,
  testLogin,
};
